var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoulderGridLogotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 986,
    viewBox: "0 0 953 986",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 952.946,
    height: 985.964,
    rx: 476.473,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.946 187.179V428.25L624.911 461.732L564.643 423.786V318.98L388.304 428.25V566.643L575.804 680.482V647L439.643 562.179V497.446L508.839 455.036L682.946 562.179V796.554L611.518 838.964L270 633.607V354.589L613.75 147L682.946 187.179Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M682.946 187.179V428.25L624.911 461.732M682.946 187.179L336.964 394.768M682.946 187.179L613.75 147L270 354.589M624.911 461.732V283.161L564.643 318.98M624.911 461.732L564.643 423.786V318.98M575.804 680.482L388.304 566.643V428.25L564.643 318.98M575.804 680.482V738.518L339.196 597.893L336.964 394.768M575.804 680.482V647L439.643 562.179V497.446M336.964 394.768L270 354.589M270 354.589V633.607L611.518 838.964M611.518 838.964L682.946 796.554V562.179M611.518 838.964V602.357M682.946 562.179L611.518 602.357M682.946 562.179L508.839 455.036L439.643 497.446M611.518 602.357L439.643 497.446",
    stroke: "black",
    strokeWidth: 13.3929
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoulderGridLogotype);
export default __webpack_public_path__ + "static/media/boulder-grid-logotype.39fe1b381683faa85895e302f9d0b38b.svg";
export { ForwardRef as ReactComponent };